import { render, staticRenderFns } from "./cusBtn2.vue?vue&type=template&id=7d67c123&scoped=true"
import script from "./cusBtn2.vue?vue&type=script&lang=js"
export * from "./cusBtn2.vue?vue&type=script&lang=js"
import style0 from "./cusBtn2.vue?vue&type=style&index=0&id=7d67c123&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67c123",
  null
  
)

export default component.exports